"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendFrontendMetadata = exports.betterFetch = void 0;
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lead_service_1 = require("./lead.service");
var object_service_1 = require("./object-service");
var settings_service_1 = require("./settings.service");
var betterFetch = function (input, init) { return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, extraParam, otpToken, finalInput;
    return __generator(this, function (_a) {
        url = typeof input === 'string' ? input : input.url;
        headers = new Headers((init === null || init === void 0 ? void 0 : init.headers) || {});
        if (url.includes('729907915433.europe-west3.run.app')) {
            headers.set('request-origin-url', window.location.href);
            extraParam = 'uuid=' + object_service_1.ObjectService.getInstance(lead_service_1.LeadService).createLead();
            url += url.includes('?') ? "&".concat(extraParam) : "?".concat(extraParam);
            otpToken = localStorage.getItem("otpToken");
            if (otpToken === null || otpToken === void 0 ? void 0 : otpToken.length) {
                url += "&otpToken=".concat(otpToken);
            }
        }
        finalInput = typeof input === 'string' ? url : new Request(url, input);
        //console.log('Modified URL:', url);
        return [2 /*return*/, fetch(finalInput, __assign(__assign({}, init), { headers: headers }))];
    });
}); };
exports.betterFetch = betterFetch;
var sendFrontendMetadata = function () { return __awaiter(void 0, void 0, void 0, function () {
    var config, res;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
                return [4 /*yield*/, (0, exports.betterFetch)((0, infrastructure_const_1._GetCloudFunctionUrl)('utilities') + "/fms-metadata", {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'request-origin-data': JSON.stringify({
                                version: __APP_VERSION__,
                                technology: (_a = config.get) === null || _a === void 0 ? void 0 : _a.technologyType,
                                tenantKey: (_b = config.get) === null || _b === void 0 ? void 0 : _b.tenantKey,
                                section: (_c = config.get) === null || _c === void 0 ? void 0 : _c.section,
                                modules: (0, cash_dom_1.default)('[data-module]')
                                    .get()
                                    .map(function (el) { return el.getAttribute('data-module'); })
                                    .filter(function (m) { return !!m; }),
                            })
                        },
                    })];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res.status];
        }
    });
}); };
exports.sendFrontendMetadata = sendFrontendMetadata;
